import { render, staticRenderFns } from "./ReferenceListField.vue?vue&type=template&id=3d6b6d5d"
import script from "./ReferenceListField.vue?vue&type=script&lang=js"
export * from "./ReferenceListField.vue?vue&type=script&lang=js"
import style0 from "./ReferenceListField.vue?vue&type=style&index=0&id=3d6b6d5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports